import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingChoice from './components/LandingChoice';
import SellersLandingPage from './components/SellersLandingPage';
import InvestorLanding from './components/InvestorLanding';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingChoice />} />
          <Route path="/sellers" element={<SellersLandingPage />} />
          <Route path="/investors" element={<InvestorLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;